import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileOpen(false);
  }, [location]);

  const navLinks = [
    { to: '/', label: '首页' },
    { to: '/category/all', label: '文章' },
    { to: '/about', label: '关于我们' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/60'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 flex items-center justify-between h-16">
        <Link
          to="/"
          className="flex items-center gap-2 group"
        >
          <span
            className={`text-xl font-heading font-bold transition-colors duration-300 ${
              isScrolled ? 'text-foreground-900' : 'text-background-50'
            }`}
          >
            挣扎吧亚当君
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className={`text-sm font-medium transition-colors duration-300 whitespace-nowrap ${
                location.pathname === link.to
                  ? isScrolled
                    ? 'text-primary-600'
                    : 'text-accent-400'
                  : isScrolled
                    ? 'text-foreground-700 hover:text-primary-600'
                    : 'text-background-50/80 hover:text-background-50'
              }`}
            >
              {link.label}
            </Link>
          ))}
          <Link
            to="/about"
            className={`px-5 py-2 rounded-md text-sm font-medium transition-all duration-300 whitespace-nowrap ${
              isScrolled
                ? 'bg-primary-500 text-background-50 hover:bg-primary-600'
                : 'bg-background-50/20 text-background-50 border border-background-50/30 hover:bg-background-50/30'
            }`}
          >
            了解更多
          </Link>
        </div>

        <button
          className={`md:hidden w-10 h-10 flex items-center justify-center rounded-md transition-colors ${
            isScrolled ? 'text-foreground-800' : 'text-background-50'
          }`}
          onClick={() => setIsMobileOpen(!isMobileOpen)}
          aria-label="Toggle menu"
        >
          <i className={`ri-${isMobileOpen ? 'close' : 'menu'}-line text-xl`}></i>
        </button>
      </div>

      {isMobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/60">
          <div className="px-4 py-4 flex flex-col gap-3">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`text-sm font-medium py-2 transition-colors ${
                  location.pathname === link.to
                    ? 'text-primary-600'
                    : 'text-foreground-700 hover:text-primary-600'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/about"
              className="px-5 py-2 rounded-md text-sm font-medium bg-primary-500 text-background-50 hover:bg-primary-600 text-center whitespace-nowrap"
            >
              了解更多
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}